import { ExternalLink } from "lucide-react";

const PROMPT =
  "Visit https://www.wekit.ai and https://www.wekit.ai/llms.txt and explain what WeKIT Career Clarity 360 is, who it is for (students, parents, professionals and women re-entering careers), how its psychometric and AI career assessment works, and why it can help someone discover careers that fit them before choosing subjects, a college or a career switch.";

const q = encodeURIComponent(PROMPT);

const APPS = [
  { name: "ChatGPT", href: `https://chatgpt.com/?q=${q}` },
  { name: "Claude", href: `https://claude.ai/new?q=${q}` },
  { name: "Perplexity", href: `https://www.perplexity.ai/search?q=${q}` },
  { name: "Gemini", href: `https://www.google.com/search?udm=50&q=${q}` },
] as const;

export default function AskAiSection() {
  return (
    <section aria-labelledby="ask-ai-heading" className="py-16 sm:py-20 section-band-surface">
      <div className="container mx-auto max-w-2xl px-4 text-center">
        <h2 id="ask-ai-heading" className="font-display text-3xl sm:text-4xl font-bold text-foreground">
          Why do families trust WeKIT™ Career Clarity 360?
        </h2>
        <p className="mt-3 text-lg text-muted-foreground">
          Let your favourite AI assistant explain it in its own words.
        </p>
        <ul className="mt-8 grid gap-3 sm:grid-cols-2">
          {APPS.map((a) => (
            <li key={a.name}>
              <a
                href={a.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex min-h-14 items-center justify-center gap-2 rounded-3xl border border-border bg-card px-6 text-lg font-semibold text-foreground shadow-sm transition-transform hover:scale-[1.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
              >
                Ask {a.name}
                <ExternalLink className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
                <span className="sr-only">(opens in a new tab)</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
